module.exports = "<svg viewBox=\"0 0 5 9\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.87266 3.90837L0.410156 0.0599336C0.24375 -0.0830351 0 0.0458711 0 0.27673V7.97361C0 8.20446 0.24375 8.33337 0.410156 8.1904L4.87266 4.34196C5.00039 4.23181 5.00039 4.01853 4.87266 3.90837Z\"/>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/html-loader!./static/icons/buttons/collapse_chevrons_right.svg
// module id = OEKl
// module chunks = 0